function UpgradeModal({
	isDarkMode,
	seats,
	redirecting,
	onUpgrade,
	onClose,
}) {
	return (
		<div className="relative z-50">
			<div className="fixed inset-0 bg-gray-900/50 transition-opacity" />
			<div
				className="fixed inset-0 z-10 flex items-start justify-center pt-20 p-4"
				onClick={onClose}
			>
				<div className="w-full max-w-md" onClick={e => e.stopPropagation()}>
					<div className={`relative transform overflow-hidden rounded-lg px-6 pt-10 pb-6 text-left shadow-xl transition-all sm:px-8 sm:pt-12 sm:pb-8 ${
						isDarkMode
							? 'bg-gray-800 outline outline-1 -outline-offset-1 outline-white/10'
							: 'bg-white'
					}`}>
						<button
							type="button"
							onClick={onClose}
							className={`absolute top-4 right-4 transition-colors ${
								isDarkMode ? 'text-gray-400 hover:text-gray-300' : 'text-gray-400 hover:text-gray-600'
							}`}
						>
							<svg
								className="h-6 w-6"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M6 18L18 6M6 6l12 12"
								/>
							</svg>
						</button>

						<div className="text-center">
							<svg
								className="mx-auto h-12 w-12 text-orange-400 mb-4"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
								/>
							</svg>

							<h3 className={`text-lg font-semibold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
								Team is Full
							</h3>

							<p className={`text-sm mb-6 ${isDarkMode ? 'text-gray-300' : 'text-gray-500'}`}>
								All {seats} seats are currently occupied.
								Upgrade your plan to add more team members.
							</p>

							<div className="flex gap-3 justify-center">
								<button
									onClick={onClose}
									className={`rounded-md px-6 py-2 text-sm font-semibold ${
										isDarkMode
											? 'bg-gray-700 text-white hover:bg-gray-600'
											: 'bg-gray-100 text-gray-700 hover:bg-gray-200'
									}`}
								>
									Cancel
								</button>
								<button
									onClick={onUpgrade}
									disabled={redirecting}
									className="rounded-md bg-blue-600 px-6 py-2 text-sm font-semibold text-white hover:bg-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
								>
									{redirecting ? 'Redirecting...' : 'Upgrade Plan'}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default UpgradeModal
